module.exports = __webpack_public_path__ + "img/14-1.3725b8ae.png";